<template>
  <div style ="background: #0D2A4C" >
    <Schedule :multiline="true" />
    <Trainings />
    <AboutCaseStudy />
    <!-- <OpenDay/> -->
    <div class="content-svg">
      <span> 
        Cunoaște 
        <br /> Trainerii
      </span>
    </div>
    <div id="trainers" >
        <div id="items" v-for="(obj,index) in trainers" :key="index">
          <div @click.stop="showModal(index)">
            <ContactPersonCard :contactPerson="obj" :isTrainer="true"></ContactPersonCard>
          </div>
        </div>
    </div>

    <v-dialog
      v-model="dialog"
      content-class="dialog"
    >
      <v-card>
        <v-card-title class="headline">
          {{ trainerToShow.name }}
        </v-card-title>
        <v-card-text>
          {{ trainerToShow.description }}
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import OpenDayInfo from "@/assets/resources/openDay.js";
import trainers from "@/assets/resources/trainers.js";
import OpenDay from "@/components/trainings-components/OpenDay";
import Schedule from "@/components/trainings-components/Schedule";
import Trainings from "@/components/trainings-components/Trainings";
import ContactPersonCard from "@/components/contact-components/ContactPersonCard";
import AboutCaseStudy from "@/components/trainings-components/AboutCaseStudy";

export default {
  components: {
    Schedule,
    Trainings,
    ContactPersonCard,
    OpenDay,
    AboutCaseStudy
  },
  data() {
    return {
      trainers,
      dialog: false,
      trainerToShow: {
        name: '',
        description: '',
      }
    };
  },
  methods: {
    showModal(index) {
      this.trainerToShow = this.trainers[index];
      this.dialog = true;
    }
  }
};
</script>

<style lang="scss" scoped>
$svg-width: 31vw;
$svg-padding: calc(30vw * 6 / 4);
$svg-displacement: 2vw;

.content-svg {
  position: relative;
  bottom:-10vh;
  background-image: url('../assets/images/left svg.svg');
  background-size: cover;
  width: $svg-width;
  padding: 0;
  padding-bottom: $svg-padding;
  right: $svg-displacement;
}

div > span {
  font-family: "Acumin Variable Concept";
  font-size: 3vw;
  position: absolute;
  text-align: center;
}

.content-svg > span {
  top: 50%;
  left: 20%;
  color: #edf6fb;
}



#trainers {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content:space-around;
  align-items: center;
  // padding-left: 15%;
  // padding-right: 15%;
}

#items {
  flex: 1 0 calc(50% - 30px);
  max-width: calc(50% - 30px);
  min-width: 200px;
  flex-shrink: 0;
  padding: 2% 10% 2% 10%;
  flex-grow: 1;
}
.path {
  position: absolute;
  width: 100%;
  height: auto;
  bottom: -1.5vh;
}
@media (max-width: 600px) {
  #trainers {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content:center;
  align-items: center;
  padding-left: 0;
  padding-right: 0;
  
}

#items {
  width: 200px !important;
  flex-shrink: 0;
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 5%;
  padding-top: 15%;
  flex-grow: 1;
  
}
@media screen and (max-width: 1023px) {
  $svg-width-mobile: 65vw;
  $svg-padding-mobile: calc(64vw * 5.9 / 4); 

  .selection {
    margin-top: 20vh;
    transform: scale(0.8);
  }

  .content-svg {
    width: $svg-width-mobile;
    padding: 0;
    padding-bottom: $svg-padding-mobile; 
    left: -5vw;
    position: relative;
    z-index: 1;
  }

  div > span {
    font-size: 6vw;
  }

  .content-svg > span {
    left: 25%;
  }

  #items {
    padding-left: 5%;
    padding-right: 5%;
  }
}

}
</style>
